import React from "react";
import {
  Theme,
  createStyles,
  makeStyles,
  useTheme,
} from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import { LectureInterface } from "../interfacesAndTypes";
import File from "./File";
import VideoFile from "./VideoFile";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      margin: "15px 0px",
    },
    details: {
      display: "flex",
      flexDirection: "column",
      flex: "1",
    },
    content: {
      flex: "1 0 auto",
    },
    image: {
      width: 75,
      height: 100,
    },
    controls: {
      margin: "10px",
    },
    gridContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, 130px)",
      div: {
        width: "100%",
      },
    },
  })
);
interface LecturePropsInterface {
  data: LectureInterface;
  video: { src: string; title: string };
  setVideo: (video: { src: string; title: string; topic: string }) => void;
}

const Lecture = (props: LecturePropsInterface) => {
  const classes = useStyles();
  const theme = useTheme();
  const { data, video, setVideo } = props;
  const { links, topic } = data;
  const videos: string[] = [];
  const presentations: string[] = [];
  const others: string[] = [];

  links.forEach((element) => {
    if (element.type === "VIDEO") {
      videos.push(element.src);
    } else if (element.type === "PRESENTATION") {
      presentations.push(element.src);
    } else if (element.type === "OTHER") {
      others.push(element.src);
    }
  });

  return (
    <Card className={classes.root} variant="outlined">
      <CardMedia
        className={classes.image}
        image={data.image || "/user.png"}
        title={data.name}
      />

      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Typography component="h6" variant="body1">
            {data.name}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {data.topic}
          </Typography>
          <div className={classes.gridContainer}>
            {videos.map((src, index) => (
              <VideoFile
                src={src}
                index={index}
                key={index}
                topic={topic || "[بدون عنوان]"}
                video={video}
                setVideo={setVideo}
              />
            ))}
            {presentations.map((present, index) => (
              <File
                src={present}
                index={index}
                type="PRESENTATION"
                key={index}
              />
            ))}
            {others.map((src, index) => (
              <File src={src} index={index} type="OTHER" key={index} />
            ))}
          </div>
        </CardContent>
      </div>
    </Card>
  );
};
export default Lecture;
